import { FolderTree } from 'lucide-vue-next';
import FileTreePanel from '@/components/panels/FileTreePanel.vue';
import type { PanelOpener } from '@/composables/use-panels.js';

export const createFileTreeOpener = (): PanelOpener => ({
	scheme: 'file-tree',
	defaultRegion: 'left',
	allowedRegions: ['left', 'right'],
	resolve(uri) {
		return {
			uri,
			title: 'Explorer',
			icon: FolderTree,
			component: FileTreePanel,
			closable: false,
		};
	},
});
